var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dashboard px-3 py-2 pb-3 d-flex flex-column gap-16"},[(
            _vm.useTpm && _vm.hasPermissions([_vm.PermissionTypeEnum.ReportIssueSolving, _vm.PermissionTypeEnum.PerformAudit])
        )?_c('dashboard-today-issue-solving'):_vm._e(),(
            _vm.useTpm &&
            _vm.hasPermissions([_vm.PermissionTypeEnum.PerformAudit, _vm.PermissionTypeEnum.Plan, _vm.PermissionTypeEnum.Response])
        )?_c('dashboard-today-maintenance'):_vm._e(),(
            _vm.hasPermissions([_vm.PermissionTypeEnum.PerformAudit, _vm.PermissionTypeEnum.Plan, _vm.PermissionTypeEnum.Response])
        )?_c('dashboard-today-audits'):_vm._e(),(_vm.hasPermissions([_vm.PermissionTypeEnum.Findings, _vm.PermissionTypeEnum.FindingManager]))?_c('dashboard-findings'):_vm._e(),(
            _vm.hasPermissions([
                _vm.PermissionTypeEnum.Measures,
                _vm.PermissionTypeEnum.MeasuresAllUsers,
                _vm.PermissionTypeEnum.MeasureView,
            ])
        )?_c('dashboard-measures'):_vm._e(),(
            _vm.hasPermissions([
                _vm.PermissionTypeEnum.PerformAudit,
                _vm.PermissionTypeEnum.Response,
                _vm.PermissionTypeEnum.MistakeCorrection,
            ])
        )?_c('dashboard-measure-verification'):_vm._e(),(
            _vm.hasPermissions([
                _vm.PermissionTypeEnum.PerformAudit,
                _vm.PermissionTypeEnum.Response,
                _vm.PermissionTypeEnum.MistakeCorrection,
            ])
        )?_c('dashboard-performed-audits'):_vm._e(),(
            _vm.hasPermissions([
                _vm.PermissionTypeEnum.PerformAudit,
                _vm.PermissionTypeEnum.Response,
                _vm.PermissionTypeEnum.MistakeCorrection,
            ])
        )?_c('dashboard-not-performed-audits'):_vm._e(),(
            _vm.hasPermissions([
                _vm.PermissionTypeEnum.PerformAudit,
                _vm.PermissionTypeEnum.Response,
                _vm.PermissionTypeEnum.MistakeCorrection,
            ])
        )?_c('dashboard-quick-stats'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }